export default {
  en: {
    settings: 'settings',
    select: 'select',
    'cancel-select': 'cancel select',
    scheduler: 'scheduler',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
    devices: 'devices',
    service: 'service',
    edit: 'edit',
    done: 'done',
    'service-groups': 'service groups',
    dashboard: 'dashboard',
    'scene-settings': 'scene settings',
    'scenes-settings': 'scenes settings',
    scenes: 'scenes',
    preferences: 'preferences',
    'add-scene': 'add scene',
    'scene-name': 'scene name',
    'scene-icon': 'scene icon',
    'add-service': 'add service',
    'remove-scene': 'remove scene',
    'edit-scene': 'edit scene',
    'remove-service': 'odebrat službu',
    'add-vizualization': 'add vizualization',
    'remove-vizualization': 'remove vizualization',
    vizualization: 'vizualization',
    vizualizations: 'vizualizations',
    'vizualization-name': 'vizualization name',
    'vizualization-file': 'file with vizualization',
    'drop-file-here': 'drop file here',
    'choose-a-file': 'choose a file',
    'no-vizualizations': 'no vizualization',
    'add-service-or-device': 'add service or device',
    'enable-edit-mode': 'enable edit mode',
    'disable-edit-mode': 'disable edit mode',
    remove: 'remove',
    notifications: 'notifications',
    logging: 'logging',
    graphs: 'graphs',
    value: 'value',
    'turned-on': 'turned on',
    'turned-off': 'turned off',
    running: 'running',
    'not-running': 'not running',
    warnings: 'warnings',
    'are-you-sure-you-want-remove': 'are you sure you want remove',
    'my-profile': 'my profile',
    'manage-users': 'manage users',
    'licence-and-services': 'licence and services',
    'plc-connection-settings': 'PLC connection',
    'turn-on': 'turn on',
    'turn-off': 'turn off',
    from: 'from',
    'users-management': 'users management',
    account: 'account',
    'user-permissions': 'user permissions',
    'add-user': 'add user',
    'service-scheduler': 'service scheduler',
    'request-form-text': 'please, write your requests using this contact form. You will get in turn the email message with the link to webpage to see the ticket resolving.',
    'request-subject': 'request subject',
    'issue-type': 'choose issue type',
    'issue-description': 'detailed issue description',
    description: 'description',
    question: 'question',
    bug: 'bug',
    'change-request': 'change request',
    problem: 'problem',
    sended: 'sended',
    'helpdesk-message': 'helpdesk message',
    'type subject of issue': 'type subject of issue',
    'write what happened': 'write what happened',
    send: 'send',
    'select-option': 'select option',
    'sending-error': 'sending error',
    'change-project': 'change project',
    loading: 'loading',
    selected: 'selected',
    place: 'place',
    group: 'group',
    icon: 'icon',
    name: 'name',
    choose: 'choose',
    'include-devices': 'include devices',
    'user-settings': 'user settings',
    'charts-and-values': 'charts and values',
    'menu-notifications': 'notifications',
    techsupport: 'techsupport',
    'menu-change-project': 'change project',
    favorite: 'favorite',
    'enable-push-notifications': 'enable push notifications',
    'first-name': 'first name',
    'last-name': 'last name',
    username: 'username',
    email: 'email',
    phone: 'phone',
    password: 'password',
    'choose-language': 'choose language',
    'enable-devices': 'enable devices',
    'is-superuser': 'is superuser',
    'user-update': 'user update',
    error: 'error',
    saved: 'saved',
    'add-next': 'add next',
    close: 'close',
    save: 'save',
    logout: 'logout',
    delete: 'delete',
    show: 'show',
    permissions: 'permissions',
    'enable-email-notifications': 'enable email notifications',
    appearance: 'appearance',
    'show-devices': 'show devices',
    'starting-screen': 'starting screen',
    'enable-advance-level': 'enable advance level',
    'enable-instaler-level': 'enable instaler level',
    'show-advance-level': 'show advance level',
    'show-instaler-level': 'show instaler level',
    'form-contains-errors': 'form contains errors',
    'passwords-do-not-match': 'passwords do not match',
    'repeat-password': 'repeat password',
    'password-change': 'password change',
    'choose-services-to-giving-permission': 'choose services to giving permission',
    'access-control': 'access control',
    'user-has-no-permissions': 'user has no permissions',
    add: 'add',
    'starting-visualization-is': 'starting visualization is',
    'not-set': 'not set',
    'choose-visualization': 'choose visualization',
    'there-is-no-visualizations': 'there is no visualizations',
    'update-visualization': 'update visualization',
    'set-as-default': 'set as default',
    services: 'services',
    'edit-permissions': 'edit permissions',
    'user-create': 'user create',
    share: 'share',
    'share-to-user': 'share',
    deselect: 'cancel selection',
    sharing: 'sharing',
    set: 'set',
    'shared-with': 'shared with',
    'read-perm': 'read',
    'write-perm': 'write',
    'execute-perm': 'execute',
    permit: 'permit',
    'of-visualization': 'visualization',
    user: 'user',
    'of-scene': 'scene',
    control: 'control',
    'set-value': 'set value',
    graph: 'graph',
    'cloud-status': 'cloud status',
    table: 'table',
    'clear-selected': 'clear selected',
    'do-set': 'set',
    cancel: 'cancel',
    'enter-text': 'enter text',
    'not-available': 'not available',
    'set-project-as-default': 'set project {0} as default',
    'default-project-set': 'default project has been set',
    refresh: 'refresh',
    enabled: 'enabled',
    disabled: 'disabled',
    last: 'last',
    argument: 'argument',
    'choose-datetime-range': 'choose datetime range',
    'from-date': 'from',
    'to-date': 'to',
    chart: 'chart',
    charts: 'charts',
    second: 'second',
    minute: 'minute',
    hour: 'hour',
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    year: 'year',
    'table-view': 'table view',
    datetime: 'datetime',
    'enter-number': 'enter number',
    'choose-notification-types': 'choose ways how to be notified',
    is: 'is',
    'advanced-view': 'advanced view',
    'simple-view': 'simple view',
    'notification-settings': 'notification settings',
    'enable-menu-collapsing': 'enable menu collapsing',
    menu: 'menu',
    navigation: 'navigation',
    'service-tile-click-navigates-to-next-level': 'service tile click navigates to devices',
    'service-group-tile-click-navigates-to-next-level': 'service group tile click navigates to services',
    'snapshot-build-datetime': 'snapshot build datetime',
    'new-project-version': 'new project version',
    'edit-place-name': 'edit place name',
    'enter-at-least-x-letters': 'enter at least {count} letters (without spaces)',
    'installer-name': 'installer name',
    'edit-service-name': 'edit service name',
    'nothing-is-here': 'nothing is here',
    'maybe-you-need-some-permissions': 'maybe you need some permissions',
    'username-must-be-valid-email-address': 'username must be valid email address',
    'reload-project': 'reload project',
    'cloud-connection': 'iCOOL 4 cloud service',
    'local-connection': 'direct local connection',
    'connection-type': 'connection type',
    'include-settings': 'include settings',
    'user-api-token-settings': 'user API token settings',
    'obtain-new-auth-token': 'obtain new API token',
    'delete-auth-token': 'delete API token',
    'token-deleted': 'token deleted',
    'token-obtained': 'token obtained',
    created: 'created',
    'first-value': 'first val.',
    'last-value': 'last val.',
    paginate: 'paginate',
    all: 'all',
    'number-of-errors': 'number of errors',
    'services-with-error': 'services with error',
    'add-panel': 'Add panel',
    'energo-panel': 'Energy panel',
    help: 'help',
    'metrics-overview-for-date-range': 'metrics overview for date range',
    'logged-vars-overview': 'logged variables overview',
    'metrics-overview': 'metrics overview',
    'delete-metrics': 'delete metrics',
    'delete-to-date': 'delete to date',
    'copy-argument-link-to-clipboard': 'Copy argument link to clipboard',
    'copied-to-clipboard': 'Copied to clipboard',
    'subscription': 'Paid services',
    'identification_number': 'IČO',
    'company': 'Firma',
    'street': 'Ulice a číslo',
    'city': 'Město',
    'zip': 'PSČ',
    'country_code': 'Kód země',
    'place-order': 'Objednat',
  },
};
